import { Link, TableCellProps } from '@servicetitan/design-system';

/**
 * Renders a table cell containing the name of a location as a link.
 *
 * @returns The rendered table cell.
 */
// TODO: Link out to the location page
const LocationNameCell = ({
  colSpan,
  className,
  ...restProps
}: TableCellProps) => {
  return (
    <td colSpan={colSpan} className={className}>
      <Link
        className='c-blue-500-i'
        href={restProps.dataItem.locationLinkToMonolith}
        target='_blank'
      >
        {restProps.dataItem.name}
      </Link>
    </td>
  );
};

export default LocationNameCell;
